import { useId } from 'react';
import { Link } from 'react-router-dom';
import { eventsQuery } from '@/features/publicsite/events/api/publicEventsApi';
import { EventCalendarItem } from '@/features/publicsite/events/EventCalendarItem';
import { EVENT_KIND } from '@/features/publicsite/events/eventKind';
import { splitTimeline } from '@/features/publicsite/events/eventTimeline';
import type { EventItem } from '@/features/publicsite/types/events/EventItem';
import { usePublicList } from '@/features/publicsite/usePublicList';
import { publicCatalog } from '@/i18n/dictionaries/publicCatalog';
import { useTranslation } from '@/i18n/useTranslation';

/** How many upcoming scientific events the research page shows before „Toate”. */
const SHOWN = 3;

/**
 * „Evenimente științifice” on /cercetare (tor.md §6.2): the research organisations' scientific
 * events, the next few of them. Not a calendar of their own — the same events, from the same national
 * calendar /evenimente shows them in, filtered to the SCIENTIFIC kind, and „Toate” opens exactly
 * that filter there.
 */
export function ResearchScientificEvents() {
  const { t } = useTranslation(publicCatalog);
  const headingId = useId();
  const all = usePublicList<EventItem>(eventsQuery({ kind: EVENT_KIND.scientific }));
  const upcoming = all ? splitTimeline(all).upcoming.slice(0, SHOWN) : null;
  const calendar = `/evenimente?kind=${EVENT_KIND.scientific}`;

  return (
    <section className="research-events" aria-labelledby={headingId}>
      <div className="section-head section-head--stacked">
        <span className="eyebrow">{t('scientificEventsEyebrow')}</span>
        <h2 id={headingId} className="cal-grid__heading">
          {t('scientificEventsHeading')}
        </h2>
        <p className="muted">{t('scientificEventsLead')}</p>
      </div>
      <div className="cal-card">
        <div className="cal-card__head">
          <h3>{t('scientificEventsNext')}</h3>
          <Link to={calendar}>{t('scientificEventsAll')}</Link>
        </div>
        {upcoming?.map((event) => (
          <EventCalendarItem key={event.id} event={event} />
        ))}
        {upcoming && upcoming.length === 0 && (
          <p className="empty-state">{t('scientificEventsEmpty')}</p>
        )}
      </div>
    </section>
  );
}
